import { render, staticRenderFns } from "./ChatToolbar.vue?vue&type=template&id=4eb828bc&"
import script from "./ChatToolbar.vue?vue&type=script&lang=ts&"
export * from "./ChatToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports